/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_Short_3Inputs */

const he_statistics_day_short_3 = /** @type {(inputs: Statistics_Day_Short_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ד`)
};

const en_statistics_day_short_3 = /** @type {(inputs: Statistics_Day_Short_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W`)
};

/**
* | output |
* | --- |
* | "W" |
*
* @param {Statistics_Day_Short_3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_short_3 = /** @type {((inputs?: Statistics_Day_Short_3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_Short_3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_short_3(inputs)
	return en_statistics_day_short_3(inputs)
});